module.exports = __webpack_public_path__ + "media/images/baseCodelco1-6f0e1d85e02e30e5260d912f6f8e231b.jpeg";